import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../common/GridLayout";
import { Localization } from "../../common/Localization";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
  Column,
  DataGrid,
  GroupPanel,
  Scrolling,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Selection,
  Toolbar as GridToolbar,
  Item as GridToolbarItem,
  Export,
  Pager,
  ColumnChooser,
  StateStoring,
  ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { FillFilters, FormatPhoneNumber } from '../../common/Utils'
import { IDLookupLayout, IDWarehouseLookupLayout } from '../../common/lookups/Layouts/IdLayouts';
import HeaderFrom from './HeaderFrom';
import XmMonitor from '../../xm/XmMonitor';
import DynamicFromLookup from '../../dynamicFormBuilder/DynamicFromLookup';
const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];

const ListGenericLookup = (props) => {
  const dataGrid = useRef(null);
  const history = useHistory();
  var accessToken = props.oidc.user.access_token;
  var currentUser = props.oidc.user;
  const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
  const formRefs = useRef({});
  const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
  const [searchPanelStatus, setSearchPanelStatus] = useState(true);
  const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
  const rowId = useRef(null);

  const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
  const gridKey = "2BCDA668-2D5B-4D36-B8C2-A93866FDDAE8";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken); }, []);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state); }, []);
  const initialFormFields = {
    IDENTITYID: '',
    NAME: '',
    PROFILECODE: '',
    IDGROUP: '',
    IDSUBGROUP: '',
    TELEPHONE_1: '',
    REFERENCE1: '',
    REFERENCE2: '',
    CREATIONDATETIME: null,
    CREATIONUSERID: '',
    AddressTELEPHONE1: '',
    REFERENCE1: '',
    REFERENCE2: '',
    LASTUPDATEDATETIME: null,
    LASTUPDATEUSERID: '',
    RECORD: '',
    COMPANYID: '',
    MODULE: '',
    AddressCITY: '',
    AddressZIP: '',
    AddressSTATE: '',
    AddressCOUNTRY: '',
    RECORDTYPE: '',
    AddressADDRESS1: '',
    AddressADDRESS2: '',

    IDTYPE: props.IdType
  };
  const [formFields, setformFields] = useState(initialFormFields);

  const onSelectionChanged = ({ selectedRowsData }) => {
    if (selectedRowsData && selectedRowsData.length == 1) {
      rowId.current = selectedRowsData[0].rowid;
    }
    else {
      rowId.current = '';
    }

    setIsEditButtonDisabled(!isEditButtonDisabled);
  };

  const handelEditClick = () => {
    const buttonUrl = "/wm/codes/edit-customer?id=" + rowId.current;
    history.push(buttonUrl);
  };

  const selectionChanged = useCallback(
    (e, tg) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      setSearchPanelStatus((prevStatus) => {
        const newStatus = !prevStatus;
        return newStatus;
      });
    },
    [selectedItems, setSelectedItems],
  );

  const handleSearch = (e) => {
    e.preventDefault();
    console.log(formFields)
  }
  const handleReset = (e) => {
    e.event.stopPropagation();
    setformFields(initialFormFields);
  }
  useEffect(() => {
    if (formFields.IDENTITYID === '' && formFields.NAME === '' && formFields.REFERENCE1 === '' && formFields.REFERENCE2 === ''
      && formFields.IDGROUP === '' && formFields.IDSUBGROUP === '' && formFields.TELEPHONE_1 === '' && formFields.PROFILECODE === ''
    )
      setResultData(loadDatasource);
  }, [formFields]);

  const handleFormLoad = useCallback(() => {
    var customerDataSource = new DataSource({
      store: new createStore({
        key: 'id',
        loadUrl: `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,
        loadParams: {
          codeType: function () {
            return "Z7";
          }
        },
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100,
      sort: [
        {
          selector: "name",
          desc: false,
        }
      ],
    });

    loadLookupFromDataSource("IDGROUP", customerDataSource, 'name', 'name');

    var shipperDataSource = new DataSource({
      store: new createStore({
        key: 'id',
        loadUrl: `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,
        loadParams: {
          codeType: function () {
            return "Z8";
          }
        },
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100,
      sort: [
        {
          selector: "name",
          desc: false,
        }
      ],
    });

    loadLookupFromDataSource("IDSUBGROUP", shipperDataSource, 'name', 'name');

  }, []);


  const loadLookupFromDataSource = (name, dataSource, valueExpr, displayExpr) => {
    if (formRefs.current[name]) {
      formRefs.current[name].instance().option('dataSource', dataSource);
      formRefs.current[name].instance().option('valueExpr', valueExpr);
      formRefs.current[name].instance().option('displayExpr', displayExpr);
    }
    else {
      console.log('not found control:');
    }
  };

  const handleFieldChange = useCallback((name, value) => {
    // console.log(name, value);
  }, []);

  const handlePrimaryLoad = useCallback(() => {
    // console.log(name, value);
  }, []);

  const loadDatasource = () => {
    let store = createStore({
      key: 'rowid',
      loadParams: formFields,
      loadUrl: `${window._env_.REACT_APP_APIS}/${data.ID.GetCustomerData}`,
      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.headers = {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        };
      },
    });
    const dataSource = new DataSource({ store: store });
    dataSource.sort([
      { selector: 'identityid', desc: false },
      { selector: 'keysequence', desc: false },
    ]);
    return dataSource;
  }
  const [resultData, setResultData] = useState(null);


  const handleValueChanged = (e) => {
    console.log(e)
  }
  const SearchLayout = [
    {
      "groupId": 1,
      "fields": [
        {
          "name": "IDENTITYID",
          "tableName": "IDMASTER",
          "label": "Identity ID",
          "type": "text",
          "required": false,
          "visible": true,
          "isLabelChanged": false,
        },
        {
          "name": "IDSUBGROUP",
          "tableName": "IDMASTER",
          "label": "Subgroup",
          "type": "select",
          "required": false,
          "visible": true,
          "isLabelChanged": false,
        },

        {
          "name": "IDAGENT",
          "tableName": "IDMASTER",
          "label": "Agent for Dynamic From",
          "type": "lookup",
          "layout": IDLookupLayout,
          "onCustomItemCreatingComponent": XmMonitor,
          "required": true,
          "visible": true,
          "isLabelChanged": false,
        },
        {
          "name": "IDAGENT2",
          "tableName": "IDMASTER",
          "label": "WareHouse",
          "type": "lookup",
          "layout": IDWarehouseLookupLayout,
          "onCustomItemCreatingComponent": XmMonitor,
          "required": true,
          "visible": true,
          "isLabelChanged": false,
        },
        {
          "name": "CREATIONDATETIME",
          "tableName": "IDMASTER",
          "label": "Creation Date",
          "type": "datetime",
          "required": false,
          "visible": false,
          "isLabelChanged": false,
        },
        {
          "name": "CREATIONUSERID",
          "tableName": "IDMASTER",
          "label": "Created By",
          "type": "text",
          "required": false,
          "visible": false,
          "isLabelChanged": false,
        },
        {
          "name": "AddressCITY",
          "tableName": "IDMASTER",
          "label": "City",
          "type": "text",
          "required": false,
          "visible": false,
          "isLabelChanged": false,
        },
        {
          "name": "AddressZIP",
          "tableName": "IDMASTER",
          "label": "Zip",
          "type": "text",
          "required": false,
          "visible": false,
          "isLabelChanged": false,
        }
      ]
    },
    {
      "groupId": 2,
      "fields": [

        {
          "name": "NAME",
          "tableName": "IDMASTER",
          "label": "Name",
          "type": "text",
          "required": false,
          "visible": true,
          "isLabelChanged": false,
        },

        {
          "name": "AddressTELEPHONE1",
          "tableName": "IDMASTER",
          "label": "Telephone - 1",
          "type": "text",
          "required": false,
          "visible": true,
          "isLabelChanged": false,
        },


        {
          "name": "LASTUPDATEDATETIME",
          "tableName": "IDMASTER",
          "label": "Last Updated",
          "type": "datetime",
          "required": false,
          "visible": false,
          "isLabelChanged": false,
        },

        {
          "name": "LASTUPDATEUSERID",
          "tableName": "IDMASTER",
          "label": "Last Updated By",
          "type": "text",
          "required": false,
          "visible": false,
          "isLabelChanged": false,
        },
        {
          "name": "AddressADDRESS1",
          "tableName": "IDMASTER",
          "label": "Address - 1",
          "type": "text",
          "required": false,
          "visible": false,
          "isLabelChanged": false,
        },
        {
          "name": "AddressADDRESS2",
          "tableName": "IDMASTER",
          "label": "Address - 2",
          "type": "text",
          "required": false,
          "visible": false,
          "isLabelChanged": false,
        }
      ]
    },
    {
      "groupId": 3,
      "fields": [
        {
          "name": "PROFILECODE",
          "tableName": "IDMASTER",
          "label": "Profile",
          "type": "text",
          "required": false,
          "visible": true,
          "isLabelChanged": false,
        },
        {
          "name": "REFERENCE1",
          "tableName": "IDMASTER",
          "label": "Reference 1",
          "type": "text",
          "required": false,
          "visible": true,
          "isLabelChanged": false,
        },
        {
          "name": "RECORD",
          "tableName": "IDMASTER",
          "label": "Record #",
          "type": "text",
          "required": false,
          "visible": false,
          "isLabelChanged": false,
        },

        {
          "name": "COMPANYID",
          "tableName": "IDMASTER",
          "label": "Company Id",
          "type": "text",
          "required": false,
          "visible": false,
          "isLabelChanged": false,
        },
        {
          "name": "MODULE",
          "tableName": "IDMASTER",
          "label": "Module",
          "type": "text",
          "required": false,
          "visible": false,
          "isLabelChanged": false,
        }



      ]
    },
    {
      "groupId": 4,
      "fields": [
        {
          "name": "IDGROUP",
          "tableName": "IDMASTER",
          "label": "Group",
          "type": "select",
          "required": false,
          "visible": true,
          "isLabelChanged": false,
        },
        {
          "name": "REFERENCE2",
          "tableName": "IDMASTER",
          "label": "Reference 2",
          "type": "text",
          "required": false,
          "visible": true,
          "isLabelChanged": false,
        },
        {
          "name": "AddressSTATE",
          "tableName": "IDMASTER",
          "label": "State",
          "type": "text",
          "required": false,
          "visible": false,
          "isLabelChanged": false,
        },
        {
          "name": "AddressCOUNTRY",
          "tableName": "IDMASTER",
          "label": "Country",
          "type": "text",
          "required": false,
          "visible": false,
          "isLabelChanged": false,
        },

        {
          "name": "RECORDTYPE",
          "tableName": "IDADDRESS",
          "label": "Record Type",
          "type": "text",
          "required": false,
          "visible": false,
          "isLabelChanged": false,
        }



      ]
    }
  ];
  const handleSubmit = (e) => {
    e.event.stopPropagation();
    let datasource = loadDatasource();
    const { IDTYPE, ...filteredFormFields } = formFields;
    const filters = FillFilters(filteredFormFields);
    datasource.filter(filters);
    setResultData(datasource);
  }
  return (
    <div className="row">
      <div className="col-md-12 main-page">
        <div id="accordion" >
          <form onSubmit={handleSearch}>
            <FormField
              currrentUser={currentUser}
              layoutId='58dfc264-a700-4e77-ae3f-8431b1b92c57'
              layoutName='WMTransactionDataEntrySearchForm'
              defaultFormSchema={SearchLayout}
              formFields={formFields}
              setformFields={setformFields}
              handleFieldValueChange={handleFieldChange}
              DYNAMICFORMSETTING={DYNAMICFORMSETTING}
              formRefs={formRefs}
              onFormLoad={handleFormLoad}
              noSpacingBeforeFirstRow={true}
            />

            <div className="mt-2 ">
              <DynamicFromLookup
                layout={IDLookupLayout}
                onValueChanged={handleValueChanged}
                onGridSelectionChanged={handleValueChanged}
                onCustomItemCreatingComponent={XmMonitor}
              />
            </div>
            <div className="mt-2 ">
              <DynamicFromLookup
                layout={IDWarehouseLookupLayout}
                onValueChanged={handleValueChanged}
                onGridSelectionChanged={handleValueChanged}
                onCustomItemCreatingComponent={XmMonitor}
              />
            </div>
            <Button className="accordianButton" text="Search" type="default" useSubmitBehavior={true} />
          </form>
        </div>
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    oidc: state.oidc
  };
}
export default connect(mapStateToProps)(ListGenericLookup);